import { useInvestmentsGraphProductionQuery } from "@/api/graphql"
import { useProductionGraphContext } from "@/components/graphs/types/bar/ProductionGraphContext"

export function useInvestmentsGraphProductionData() {
	const { graphInterval, startTime, endTime } = useProductionGraphContext()

	return useInvestmentsGraphProductionQuery({
		startTime,
		endTime,
		interval: graphInterval,
	})
}
